import { useMutation, useQuery } from "react-query";
import { API, IdUser } from "./apiConfig";
import { API_Content } from "./schema/API_Content";

//------------- contents ------------------//

// add new Blog in content Unit

export const addNewBlog = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.ADD_NEW_BLOG, queryData);
};

export const getBlogListCategory = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };
  return API.post(API_Content.blog.GET_BLOG_LIST, data);
};

export const addNewBlogCategory = (data) => {
  data.IdUser = IdUser;
  return API.post(API_Content?.blog?.ADD_NEW_BLOG_CATEGORY, data);
};

export const updateBlogCategory = (data) => {
  data.IdUser = IdUser;
  return API.post(API_Content?.blog?.UPDATE_BLOG_CATEGORY, data);
};

export const deleteBlogCategory = (data) => {
  data.IdUser = IdUser;
  return API.post(API_Content.blog?.DELETE_BLOG_CATEGORY, data);
};

export const getBlogList = (pageNumber, search) => {
  // data.IdUser = IdUser;
  const data = {
    IdUser: IdUser,
    PageNumber: pageNumber,
    search: search,
  };

  return API.post(API_Content.blog?.GET_BLOG_TABLE, data);
};

export const getLikeMemeberBlog = (article_id) => {
  const data = {
    article_id,
    IdUser,
  };
  return API.post(API_Content.blog.GET_LIKE_MEMEBER_BLOG, data);
};

// article_id
// IdUser

export const deleteBlog = (article_id) => {
  const data = {
    article_id,
    IdUser,
  };
  return API.post(API_Content.blog.DELETE_BLOG, data);
};

// upadate a blog

export const updateBlog = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.blog.EDIT_BLOG, queryData);
};

//------------- slider ------------------//

// add new Slider

export const addSlider = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.ADD_NEW_SLIDER, queryData);
};

export const getSliderList = (pageNumber, locationFilter, search) => {
  // data.IdUser = IdUser;
  const data = {
    IdUser,
    PageNumber: pageNumber,
    locationFilter,
    search,
  };
  return API.post(API_Content.FETCH_SLIDER_LIST, data);
};

export const ChangeSliderStatus = (slide_id) => {
  const data = {
    IdUser,
    slide_id,
  };
  return API.post(API_Content.CHANGE_SLIDE_STATUS, data);
};

export const updateSlider = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.UPDATE_SLIDER, queryData);
};

export const getSliderOption = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.slider.GET_SLIDER_OPTION, data);
};

//------------- Frequent Question ------------------//

export const addCategoryQuestion = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.ADD_CATEGORY_QUESTION, queryData);
};

export const getCategoryList = (PageNumber, search) => {
  const data = {
    IdUser,
    search,
    PageNumber,
  };

  return API.post(API_Content.GET_CATEGORY_LIST, data);
};

export const deleteCategory = (category_id) => {
  const data = {
    category_id,
    IdUser,
  };
  return API.post(API_Content.DELETE_CATEGORY, data);
};

export const updateCategory = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.UPDATE_CATEGORY, queryData);
};

export const getAskQuestionList = (PageNumber, search) => {
  const data = {
    IdUser,
    PageNumber,
    search,
  };
  return API.post(API_Content.GET_ASK_QUESTION_LIST, data);
};

export const deleteAskQuestion = (FAQ_id) => {
  const data = {
    IdUser,
    FAQ_id,
  };
  return API.post(API_Content.DELETE_ASK_QUESTION, data);
};

export const updateAskQuestion = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.UPDATE_ASK_QUESTION, queryData);
};

// add new ask question

export const addNewASkQuestion = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.INSERT_NEW_ASK_QUESTION, queryData);
};

//-------------Prodcut Property ------------------//

// get all category

export const fetchAllCatergory = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.GET_CATEGORY_LIST, data);
};

// add new property level 1

export const addNewPeroperty = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.INSERT_NEW_PROPERTY, queryData);
};

// get property list table level 1

export const getPropertyList = (PageNumber, search) => {
  const data = {
    IdUser,
    PageNumber,
    search,
  };
  return API.post(API_Content.GET_PROPERTY_LIST, data);
};

// get all property list

export const getALLPropertyList = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.GET_PROPERTY_LIST, data);
};

// notification

export const addNewNotification = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.INSERT_NEW_NOTIFICATION, queryData);
};

export const deletePropertyLevelOne = (property_id) => {
  const data = {
    IdUser,
    property_id,
  };
  return API.post(API_Content.DELETE_PROPERTY_LEVEL_ONE, data);
};

export const getNotificationList = (PageNumber, search) => {
  const data = {
    search,
    PageNumber,
    IdUser,
  };
  return API.post(API_Content.notification.GET_NOTIFICATION_LIST, data);
};

// property

export const updatePropertyLevelOne = (queryData) => {
  queryData.IdUser = IdUser;

  return API.post(API_Content.UPDATE_PROPERTY_LEVEL_ONE, queryData);
};

export const addNewPropertyLevelTow = (queryData) => {
  queryData.IdUser = IdUser;

  return API.post(API_Content.INSERT_NEW_PROPERTY_LEVEL_TWO, queryData);
};

export const getPropertyListLevelTow = (PageNumber, search) => {
  const data = {
    PageNumber,
    IdUser,
    search,
  };

  return API.post(API_Content.GET_ALL_PROPERTY_LIST_LEVEL_TOW, data);
};

export const getAllPropertyLevelTow = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Content.GET_ALL_PROPERTY_LIST_LEVEL_TOW, data);
};

export const deletePropertyLevel2 = (feature_id) => {
  const data = {
    IdUser,
    ...feature_id,
  };

  return API.post(API_Content.DELETE_PROPERTY_LEVEL_TWO, data);
};

export const updatePropertyLevel2 = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.UPDATE_PROPERTY_LEVEL_TWO, queryData);
};

//-------------Area Coverd------------------//

// country

export const addNewCountry = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.country.ADD_NEW_COUNTRY, queryData);
};

export const deleteCountry = (country_id) => {
  const data = {
    country_id,
    IdUser,
  };
  return API.post(API_Content.area_coverd.country.DELTE_COUNTRY, data);
};

export const updateCountry = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.country.UPDATE_COUNTRY, queryData);
};

export const getCountryList = (PageNumber, search) => {
  const data = {
    IdUser,
    PageNumber,
    search,
  };

  return API.post(API_Content.area_coverd.country.GET_COUNTRY_LIST, data);
};

// province

export const addNewProvince = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.province.ADD_NEW_PROVINCE, queryData);
};

export const deleteProvince = (province_id) => {
  const data = {
    province_id,
    IdUser,
  };

  return API.post(API_Content.area_coverd.province.DELTE_PROVINCE, data);
};

export const updateProvince = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.province.UPDATE_PROVINCE, queryData);
};

export const getProvinceList = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };

  return API.post(API_Content.area_coverd.province.GET_PROVINCE_LIST, data);
};

export const getCountryOption = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.area_coverd.province.GET_COUNTRY_OPTION, data);
};

// city

export const addNewCity = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.city.ADD_NEW_CITY, queryData);
};

export const deleteCity = (city_id) => {
  const data = {
    city_id,
    IdUser,
  };

  return API.post(API_Content.area_coverd.city.DELTE_CITY, data);
};

export const updateCity = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.city.UPDATE_CITY, queryData);
};

export const getCityList = (PageNumber, search) => {
  const data = {
    PageNumber,
    IdUser,
    search,
  };
  return API.post(API_Content.area_coverd.city.GET_CITY_LIST, data);
};

export const getProvinceOption = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Content.area_coverd.city.GET_PROVINCE_OPTION, data);
};

// area

export const addNewArea = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.area.ADD_NEW_AREA, queryData);
};

export const deleteArea = (area_id) => {
  const data = {
    area_id,
    IdUser,
  };

  return API.post(API_Content.area_coverd.area.DELTE_AREA, data);
};

export const updateArea = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.area_coverd.area.UPDATE_AREA, queryData);
};

export const getAreaList = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };

  return API.post(API_Content.area_coverd.area.GET_AREA_LIST, data);
};

//------------- product category ------------------//

// Product Levels

export const addProductLevel = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(
    API_Content.product_category.productLevel.INSERT_NEW_CATEGORY,
    queryData
  );
};

export const updateProductLevel = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(
    API_Content.product_category.productLevel.UPDATE_CATEGORY,
    queryData
  );
};

export const deleteProductLevel = (queryData) => {
  const data = {
    category_id: queryData,
    IdUser: IdUser,
  };

  return API.post(
    API_Content.product_category.productLevel.DELETE_CATEGORY,
    data
  );
};

export const getLevel1List = (search) => {
  return API.get(
    `${API_Content.product_category.productLevel.GET_LEVEL_ONE_LIST}?search=${search}`
  );
};

export const getLevve2List = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };

  return API.post(
    API_Content.product_category.productLevel.GET_LEVEL_TWO_LIST,
    data
  );
};

export const getLevel3List = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };

  return API.post(
    API_Content.product_category.productLevel.GET_LEVEL_TREE_LIST,
    data
  );
};

// Brands

export const addNewBrand = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(
    API_Content.product_category.Brand.INSERT_NEW_BRAND,
    queryData
  );
};

export const updateBrand = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.product_category.Brand.UPDATE_BRAND, queryData);
};

export const deleteBrand = (brand_id) => {
  const data = {
    IdUser,
    brand_id,
  };

  return API.post(API_Content.product_category.Brand.DELETE_BRAND, data);
};

export const getBrandList = (PageNumber, search) => {
  const data = {
    PageNumber,
    search,
    IdUser,
  };

  return API.post(API_Content.product_category.Brand.GET_BRAND_LIST, data);
};

// genders

export const addNewGender = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(
    API_Content.product_category.gender.INSERT_NEW_GENDER,
    queryData
  );
};

export const updateGender = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.product_category.gender.UPDATE_GENDER, queryData);
};

export const deleteGender = (gender_id) => {
  const data = {
    gender_id,
    IdUser,
  };
  return API.post(API_Content.product_category.gender.DELETE_GENDER, data);
};

export const getGenderList = (PageNumber, search) => {
  const data = {
    IdUser,
    search,
    PageNumber,
  };
  return API.post(API_Content.product_category.gender.GET_GENDER_LIST, data);
};

// occation

export const addNewOccation = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(
    API_Content.product_category.occation.INSERT_NEW_OCCATION,
    queryData
  );
};

export const updateOccation = (queryData) => {
  queryData.IdUser = IdUser;

  return API.post(
    API_Content.product_category.occation.UPDATE_OCCATION,
    queryData
  );
};

export const deleteOccation = (occasion_id) => {
  const data = {
    IdUser,
    occasion_id,
  };
  return API.post(API_Content.product_category.occation.DELETE_OCCATION, data);
};

export const getOccationList = (PageNumber, search) => {
  const data = {
    IdUser,
    search,
    PageNumber,
  };
  return API.post(
    API_Content.product_category.occation.GET_OCCATION_LIST,
    data
  );
};

export const changeStatusOccation = (occasion_id) => {
  const data = {
    occasion_id,
    IdUser,
  };

  return API.post(
    API_Content.product_category.occation.CHANGE_OCCATION_STATUS,
    data
  );
};

//------------- products ------------------//

// add new Product

export const addNewProduct = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(
    API_Content.product.add_product.INSERT_NEW_PRODUCT,
    queryData
  );
};

export const getSupplierList = () => {
  return API.get(API_Content.product?.add_product.GET_SUPPLIER_LIST);
};

export const uploadImgPath = (file) => {
  return API.post(
    API_Content.product?.add_product?.UPLOAD_IMG_RICH_TEXT_EDITOR,
    file
  );
};

export const getProductDetail = (IdProducts) => {
  const data = {
    IdProducts,
    IdUser,
  };
  return API.post(API_Content.product.edit_product?.GET_PRODUCT_DETAIL, data);
};

export const editProduct = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.product.edit_product.EDIT_PRODUCT, queryData);
};

// get my product and show

// export const getMyProduct = () => {};

export const getNotSubmitedProduct = () => {};

// change status product
export const changeStatusProduct = (productId) => {
  const data = {
    IdUser,
    product_id: productId,
  };
  return API.post(API_Content.my_product.GET_PRODUCT_CHANGE_STATUS, data);
};

export const getActivProductList = () => {};

export const getEndedProductList = () => {};

export const getInventoryList = () => {
  return API.get(API_Content.product.add_product.GET_INVENTROY_LIST);
};

// Rocket Product

export const getRockedProductList = (search) => {
  const data = {
    search,
    IdUser,
    status: "NotActive",
  };

  return API.post(API_Content.product.rocked_product.GET_ROCKED_LIST, data);
};

export const ChangeRockedProductStatus = (product_id) => {
  const data = {
    product_id,
    IdUser,
  };

  return API.post(
    API_Content.product.rocked_product.CHANGE_ROCKET_PRODUCT_STATUS,
    data
  );
};

export const DeleteRockedProduct = (product_id) => {
  const data = {
    IdUser,
    product_id,
  };

  return API.post(
    API_Content.product.rocked_product.DELETE_ROCKET_PRODUCT,
    data
  );
};

// Finished Product

export const getFinishedProduct = (PageNumber, search, status) => {
  const data = {
    IdUser,
    PageNumber,
    search,
    inventoryStatus: "عدم موجودی",
    status,
  };
  return API.post(
    API_Content.product.finished_prodcut.GET_FINISHED_PRODUCT,
    data
  );
};

export const getNotActiveProduct = (PageNumber, search, status) => {
  const data = {
    IdUser,
    PageNumber,
    search,
    status,
  };
  return API.post(
    API_Content.product.finished_prodcut.GET_FINISHED_PRODUCT,
    data
  );
};

export const deleteFinishedProduct = (product_id) => {
  const data = {
    IdUser,
    product_id,
  };

  return API.post(
    API_Content.product.finished_prodcut.DELETE_FINISHED_PRODUCT,
    data
  );
};

export const applyExitProduct = (product_id) => {
  const data = {
    IdUser,
    product_id,
  };

  return API.post(
    API_Content.product.finished_prodcut.APPLY_TO_EXIST_PRODUCT,
    data
  );
};

export const updateFinishedStatus = (product_id) => {
  const data = {
    IdUser,
    product_id,
  };

  return API.post(
    API_Content.product.finished_prodcut.ROCKET_FINISHED_PRODUCT,
    data
  );
};

// active product

export const getActiveProduct = (PageNumber) => {
  const data = {
    PageNumber,
    IdUser,
    status: "Active",
  };

  return API.post(API_Content.product.active_product.GET_ACTIVE_PRODUCT, data);
};

// dashboard content
export const getInformationDashboard = () => {
  const data = {
    IdUser,
  };
  return API.post("/UnitContent/Dashboard/UnitContentInformation", data);
};

// Rocked Inventroy

// export const applyRockedProduct = (queryData) => {
//   const data = {
//     IdUser,
//     queryData,
//   };

//   return API.post(
//     API_Content.product.rocked_product.CHANGE_PRODUCT_INVENTORY_STATUS,
//     queryData
//   );
// };

// export const getRockedOptionProduct = () => {
//   return API.get(API_Content.product.rocked_product.GET_ROCKED_LIST_OPTION);
// };

// my product

export const getMyProductList = (PageNumber, status, brand, search) => {
  const data = {
    PageNumber,
    ...status,
    search,
    IdUser,
    brand_id: brand,
  };
  return API.post(API_Content.my_product.GET_MY_PRODUCT_LIST, data);
};

// Edit Seo

export const editSeo = (data) => {
  data.IdUser = IdUser;

  return API.post(API_Content.seo.EDIT_SEO, data);
};

export const getSeoInfo = (data) => {
  data.IdUser = IdUser;

  return API.post(API_Content.seo.GET_SEO_INFO, data);
};
// delete product
export const deleteProduct = (ProductId) => {
  const data = {
    IdUser,
    product_id: ProductId,
  };
  return API.post(API_Content.my_product.DELETE_PRODUCT, data);
};

// get ladder porduct
export const getLadderPorduct = (productId) => {
  const data = {
    product_id: productId,
    IdUser,
  };
  return API.post(API_Content.my_product.GET_LADDER_PRODUCT, data);
};

// share product
export const shareProduct = (IdProducts) => {
  const data = {
    IdProducts,
    IdUser,
  };
  return API.post(API_Content.my_product.SHARE_PRODUCT, data);
};

export const shareMultiProduct = (IdProducts) => {
  const data = {
    IdProducts,
    IdUser,
  };
  return API.post(API_Content.my_product.SHARE_PRODUCTS, data);
};

export const backProductt = (dataProduct) => {
  const data = {
    ...dataProduct,
    IdUser,
  };
  return API.post(API_Content.my_product.BACK_PRODUCT, data);
};

// get list rocket product
export const getListRocketProduct = () => {
  const data = {
    IdUser,
  };
  return API.post(API_Content.my_product.GET_ROCKET_PRODUCT, data);
};

// add rocket product
export const addRocketProduct = (store_id) => {
  const data = {
    store_id,
    IdUser,
  };
  return API.post(API_Content.my_product.Add_ROCKET_PRODUCT, data);
};

// get all brands

export const getAllBrands = () =>
  API.get(API_Content.my_product.GET_ALL_BRANDS);

// share product to telegram

export const shareProductToTelegram = (dataProduct) => {
  const data = {
    ...dataProduct,
    IdUser,
  };
  return API.post(API_Content.my_product.SHARE_PRODUCT_TELEGRAM, data);
};

// add Template Table text

export const getTextTemplateList = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.templateText.GET_TEMPLATE_LIST, data);
};

export const addTemplateText = (queryData) => {
  queryData.IdUser = IdUser;

  return API.post(API_Content.templateText.ADD_TEMPLATE_TEXT, queryData);
};

export const updateTextTempate = (data) => {
  data.IdUser = IdUser;
  return API.post(API_Content.templateText.UPDATE_TEMPLATE_TEXT, data);
};

export const deleteTextTempalte = (temp_id) => {
  const data = {
    IdUser,
    temp_id,
  };

  return API.post(API_Content.templateText.DELETE_TEMPLATE_TEXT, data);
};

// Official Holiday

export const insertOfficialHoliday = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.holiday.INSERT_NEW_HOLIDAY, queryData);
};

export const updateOfficialHoliday = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.holiday.UPDATE_HOLIDAY, queryData);
};

export const deleteHoldiay = (queryData) => {
  queryData.IdUser = IdUser;
  return API.post(API_Content.holiday.DELETE_HOLIDAY, queryData);
};

export const getOfficialHolidayList = (PageNumber, search) => {
  const data = {
    search,
    PageNumber,
    IdUser,
  };
  return API.post(API_Content.holiday.GET_LIST_HOLDIAY, data);
};

// update product

export const updateProduct = (queryData) => {
  queryData.append("IdUser", IdUser);
  return API.post(API_Content.product.edit_product.EDIT_PRODUCT, queryData);
};

export const deleteChildImageProduct = (data) => {
  data.IdUser = IdUser;
  return API.post(
    API_Content.product.edit_product.DELETE_CHILD_IMAGE_PRODUCT,
    data
  );
};

export const getAllPropertyLevelTwo = () => {
  const data = {
    IdUser,
  };

  return API.post(API_Content.GET_ALL_PROPERTY_LIST_LEVEL_TOW, data);
};

export const getChangeBrandStatus = (id) => {
  const data = {
    IdUser,
    ...id,
  };
  return API.post("/UnitContent/Category/ChangeBrandStatus", data);
};

export const getUpdateBrandSeo = (data) =>
  API.post("/UnitContent/Seo/UpdateSeo", {
    IdUser,
    ...data,
  });
export const getShowSeo = (data) =>
  API.post("/UnitContent/Seo/ShowSeo", {
    IdUser,
    ...data,
  });
